export default __webpack_public_path__ + "static/news-1-c1cd6769083e6bc1f5c7e9f985cc2bc9.png";